import IDHeroSection from "./components/HeroSection";
import IDCitiesDirectory from "./components/CitiesDirectory";
import IDStateResources from "./components/StateResources";
import IDFAQSection, { faqs } from "./components/FAQSection";
import IDFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function IdahoPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Idaho"
        state="Idaho"
        stateAbbr="ID"
        route="/states/idaho"
        title="Idaho Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Idaho — Boise, Meridian, Nampa, Idaho Falls, Pocatello, and Coeur d'Alene. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Idaho, United States"
        geoPosition="44.0682;-114.7420"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        areaServedList={[{ "@type": "State", name: "Idaho" }]}
        serviceAreaDesc="Fast Passport Center serves Idaho travelers with expedited and emergency passport processing. Headquarters in Washington, DC with remote service across all Idaho cities."
      />
      <IDHeroSection />
      <IDCitiesDirectory />
      <IDStateResources />
      <IDFAQSection />
      <SEOCrossLinks state="ID" />
      <IDFinalCTA />
    </div>
  );
}